module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/icon_pin-0b15597f034245b91317bdd1bf1b5949.svg";